import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Tooltip,
} from "@mui/material";
import { useContext, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import "../../../../Tooltip/styles/tooltip.css";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import { FormContext } from "../context/FormProvider";
import * as Messages from "../messages/messages.js";
import ResponsiveRow from "../Slides/ResponsiveRow.jsx";
import "./styles/new-select.css";
import "./styles/new-text.css";

const AdditionalServicesField = ({
  idProp,
  label,
  req,
  state,
  setState,
  debouncedSave,
  setIsLoading,
  disabledInput,
  invalidData,
  type,
  servicesArray,
  setServicesArray,
}) => {
  const { requestStatus, handleInputDisable } = useContext(FormContext);
  const [open, setOpen] = useState(false);
  const { userId } = useContext(DashboardContext);
  const [additionalServices, setAdditionalServices] = useState({
    "Water Truck": "Water Truck",
    "Street Sweeping": "Street Sweeping",
    "Perimeter Protection - Filtrexx": "Perimeter Protection - Filtrexx",
    "Perimeter Protection - Wattle": "Perimeter Protection - Wattle",
    "Inlet Protection - Combo Guard": "Inlet Protection - Combo Guard",
    "Trackout Pad - 12'x24'": "Trackout Pad - 12'x24'",
    "Trackout Pad - 30'x50'": "Trackout Pad - 30'x50'",
    "Graffiti Removal": "Graffiti Removal",
    "Wire Back Silt Fence": "Wire Back Silt Fence",
    "Safety Fence": "Safety Fence",
    "Stucco Pit - 4'x4'": "Stucco Pit - 4'x4'",
    "Paint Barrel (55gal)": "Paint Barrel (55gal)",
    "Spill Kit": "Spill Kit",
    "Hot Water Pressure Wash": "Hot Water Pressure Wash",
  });

  const [newService, setNewService] = useState("");
  return (
    <ResponsiveRow type="center">
      <div className={`select-info-container ${type}-info-container`}>
        <FormControl
          variant="outlined"
          id="select-form"
          classes={{ root: "form-select-root" }}
          className={`${type}-form-control ${
            disabledInput === false && invalidData
              ? "revised-input"
              : disabledInput === true
                ? "disable-text"
                : req
                  ? "required"
                  : ""
          }`}
        >
          <InputLabel
            id="select-label"
            htmlFor="select-input"
            classes={{ shrink: "select-label-shrink" }}
            className={`${idProp}-select-field-label`}
          >
            {label}
          </InputLabel>
          <Select
            id="select-field"
            labelId="select-field-label"
            className={`${idProp}-input`}
            label={label}
            value={servicesArray}
            onChange={(e) => {
              const { value } = e.target;
              let newValue = value[value.length - 1];
              console.log("Value: ", value);
              console.log("NEW VALUE: ", newValue);
              let newState = {};
              if (newValue === "" || newValue === undefined) {
                setServicesArray([]);
                newState = {
                  ...state,
                  [idProp]: "",
                };
                setState(newState);
              } else {
                setServicesArray(
                  typeof value === "string" ? value.split(",") : value,
                );
                newState = {
                  ...state,
                  [idProp]:
                    typeof value === "string" ? value : value.join(", "),
                };
                setState(newState);

                if (debouncedSave && setIsLoading) {
                  setIsLoading(true);
                  debouncedSave.mutate(newState);
                }
              }
            }}
            multiple
            MenuProps={{
              id: "select-field-menu",
              className: "select-field-menu",
              PaperProps: {
                className: "select-field-paper",
              },
            }}
            inputProps={{
              id: "select-input",
              name: `select-input`,
            }}
            disabled={
              handleInputDisable(idProp, state, disabledInput, userId) === true
            }
            autoComplete="off"
            autoCapitalize="words"
            classes={{
              root: "select-field-root",
              input: "select-field-input",
            }}
          >
            <MenuItem
              value={""}
              id="select-field-placeholder"
              className="select-placeholder"
            >
              Clear Field
            </MenuItem>
            {Object.keys(additionalServices).map((service) => (
              <MenuItem
                key={additionalServices[service]}
                value={additionalServices[service]}
                className="select-menu-item"
              >
                {additionalServices[service]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Tooltip
          id="tf-tooltip"
          title={Messages[`${idProp}Message`] || ""}
          classes={{
            tooltip: "text-field-tooltip",
            popper: "text-field-popper",
            arrow: "text-field-arrow",
            tooltipPlacementLeft: "text-field-right",
          }}
          placement={"top"}
          arrow
          open={open}
          sx={{
            backgroundColor: "rgb(0, 0, 0, 0.8) !important",
          }}
        >
          <InfoCircle
            className="text-info-circ"
            id={`info-${idProp}`}
            color="white"
            size={30}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
          />
        </Tooltip>
      </div>
      <div className="add-service-container">
        <div className="text-info-container">
          <FormControl
            variant="outlined"
            id="text-form"
            classes={{ root: "form-text-root" }}
            className={"specialServices-form-control"}
          >
            <InputLabel
              id="text-field-label"
              htmlFor="text-input"
              classes={{ shrink: "text-field-label-shrink" }}
              className={`${idProp}-text-field-label`}
            >
              Other Services
            </InputLabel>
            <OutlinedInput
              type="text"
              id="text-field"
              className="specialServices-input"
              labelId="text-field-label"
              label="Other Services"
              value={newService}
              onChange={(e) => setNewService(e.target.value)}
              classes={{
                root: "text-field-root",
                input: "text-field-input",
                notchedOutline: "text-notchedOutline",
              }}
            />
          </FormControl>
          <Tooltip
            id="tf-tooltip"
            title={Messages[`${idProp}Message`] || ""}
            classes={{
              tooltip: "text-field-tooltip",
              popper: "text-field-popper",
              arrow: "text-field-arrow",
              tooltipPlacementLeft: "text-field-right",
            }}
            placement={"top"}
            arrow
            open={open}
            sx={{
              backgroundColor: "rgb(0, 0, 0, 0.8) !important",
            }}
          >
            <InfoCircle
              className="text-info-circ"
              id={`info-${idProp}`}
              color="white"
              size={30}
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            />
          </Tooltip>
        </div>
        <Button
          className="add-service-button"
          id="add-service"
          variant="contained"
          color="primary"
          onClick={() => {
            if (newService) {
              let newState = [...servicesArray, newService];
              setServicesArray(newState);
              setState((prev) => ({
                ...prev,
                specialServices: newState.join(", "),
              }));
              setNewService("");
            }
          }}
        >
          Add
        </Button>
      </div>
    </ResponsiveRow>
  );
};

export default AdditionalServicesField;
